export default "__VITE_ASSET__0YvDyot7__"